<template>
  <div class="object">
    <el-select
      v-model="Project"
      :placeholder="$t('placeholder.selectPlaceholder')"
      size="mini"
      style="width: 80%"
      @change="changeObject"
    >
      <el-option
        v-for="item in ProjectList"
        :key="item.id"
        :label="item.name"
        :value="item.id"
      >
      </el-option>
    </el-select>
  </div>
</template>
<script>
import { setObject, getProject } from "@/utils/auth";
export default {
  mounted() {
    if (getProject()) {
      this.Project = Number(getProject());
      console.log(this.Project, "this.Project");
    }
    //  else {
    //   this.Project = 1;
    // }
    this.language = this.$i18n.locale;
    this.userInfo = this.$store.getters.user;
    this.ProjectList = this.userInfo.projectVos;
  },
  data() {
    return {
      ProjectList: "",
      Project: "",
      userInfo: "",
      language: "",
    };
  },
  methods: {
    // 修改部门信息
    changeObject(val) {
      // console.log(this.Project);
      setObject(val);
      this.$router.go(0);
    },
  },
  computed: {
    setlanguage() {
      return this.$store.getters.language;
    },
  },
  watch: {
    setlanguage: function () {
      this.language = this.$i18n.locale;
    },
    "$store.getters.user": function (newValue, oldValue) {
      this.ProjectList = newValue.projectVos;
    },
  },
};
</script>
<style>
.object {
  clear: both;
  z-index: 99999;
  position: absolute;
  left: 50%;
  /* background-color: red; */
  top: 10px;
}
</style>
